/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Search_PlaceholderInputs */

const en_us2_plan_build_search_placeholder = /** @type {(inputs: Plan_Build_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by name, muscle or equipment`)
};

const pt_br2_plan_build_search_placeholder = /** @type {(inputs: Plan_Build_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar por nome, músculo ou equipamento`)
};

const es_419_plan_build_search_placeholder = /** @type {(inputs: Plan_Build_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca por nombre, músculo o equipo`)
};

const pt_pt2_plan_build_search_placeholder = /** @type {(inputs: Plan_Build_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar por nome, músculo ou equipamento`)
};

const fr_fr2_plan_build_search_placeholder = /** @type {(inputs: Plan_Build_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom, muscle ou matériel`)
};

const de_de2_plan_build_search_placeholder = /** @type {(inputs: Plan_Build_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Name, Muskel oder Ausrüstung suchen`)
};

const it_it2_plan_build_search_placeholder = /** @type {(inputs: Plan_Build_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca per nome, muscolo o attrezzatura`)
};

/**
* | output |
* | --- |
* | "Search by name, muscle or equipment" |
*
* @param {Plan_Build_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_search_placeholder = /** @type {((inputs?: Plan_Build_Search_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Search_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_search_placeholder(inputs)
	if (locale === "es-419") return es_419_plan_build_search_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_search_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_search_placeholder(inputs)
	if (locale === "de-DE") return de_de2_plan_build_search_placeholder(inputs)
	if (locale === "it-IT") return it_it2_plan_build_search_placeholder(inputs)
	return en_us2_plan_build_search_placeholder(inputs)
});
export { plan_build_search_placeholder as "plan-build.search_placeholder" }